import { ReactElement, useState } from "react";
import Font from "@/src/components/base/Font";
import style from "./index.module.scss";
import { Color } from "../../../../styles/typescript/types/color";

const Adornment = ({
  children,
  id,
  ...props
}: {
  children?: JSX.Element;
  id?: string;
  onClick?: () => void;
}): ReactElement => {
  const handleClick = () => {
    if (props.onClick) {
      props.onClick();
    }
  };
  return (
    <span onClick={handleClick} id={id}>
      {children}
    </span>
  );
};

const TextFields = (props: {
  onChange?: (e: any) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  label?: string;
  type?: string;
  placeholder?: string;
  maxLength?: number;
  value?: string;
  helperText?: string;
  helperCondition?: boolean;
  endAdornment?: JSX.Element;
  onEndAdornment?: () => void;
  endAdornmentCondition?: boolean;
  helperTextColor?: Color;
  condition?: "empty" | "true" | "false";
  id?: string;
  adornmentId?: string;
}): ReactElement => {
  const [state, setState] = useState({
    focus: false,
  });
  const handleChange = (e: any) => {
    if (props.onChange) {
      props.onChange(e);
    }
  };

  const handleFocus = () => {
    setState({ ...state, focus: true });
    if (props.onFocus) {
      props.onFocus();
    }
  };

  const handleBlur = () => {
    setState({ ...state, focus: false });
    if (props.onBlur) {
      props.onBlur();
    }
  };

  const handleEndAdornment = () => {
    if (props.onEndAdornment) {
      props.onEndAdornment();
    }
  };

  const classConditionProps = () => {
    if (props?.condition === "true") {
      return style["box-input--focus"];
    } else if (props?.condition === "false") {
      return style["box-input--error"];
    } else if (state.focus) {
      return style["box-input--focus"];
    } else {
      return "";
    }
  };
  return (
    <div>
      <Font variant="subtitle-2-semibold" color="mine_shaft">
        {props.label}
      </Font>
      <div className={`${style["box-input"]} ${classConditionProps()} `}>
        <input
          id={props.id}
          className={style.input}
          type={props.type}
          onChange={(e: any) => handleChange(e)}
          onFocus={() => handleFocus()}
          onBlur={() => handleBlur()}
          placeholder={props.placeholder}
          maxLength={props.maxLength}
          value={props.value}
        />
        {props.endAdornmentCondition && (
          <Adornment onClick={handleEndAdornment} id={props?.adornmentId}>
            {props.endAdornment}
          </Adornment>
        )}
      </div>

      <div className={style["helper-text"]}>
        <Font variant="caption-1-medium" color={props.helperTextColor}>
          {props?.helperCondition ? props.helperText : ""}
        </Font>
      </div>
    </div>
  );
};

TextFields.defaultProps = {
  label: "",
  type: "text",
  placeholder: "",
  maxLength: 30,
  value: "",
  helperText: "",
  endAdornment: <span />,
  endAdornmentCondition: false,
  helperTextColor: "white",
  condition: "empty",
};

export default TextFields;
